import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import KPICard from '@/components/agents/KPICard.jsx';
import useAppStore from '../../store';

const TOKEN_SERIES = [24, 31, 28, 44, 39, 58, 52, 67, 61, 74];

const REVENUE_SERIES = [18, 22, 20, 29, 34, 31, 42, 47, 44, 48.2];

/**
 * Cockpit KPI row (T2a): four stat cards sourced from the real store
 * (agents/approvals slices); no basis exists in the mocks for trend
 * deltas, so revenue/tokens ship with flat deltas.
 */
function CockpitKPIRow() {
  const navigate = useNavigate();
  const agents = useAppStore((state) => state.agents);
  const approvals = useAppStore((state) => state.approvals);

  const runningAgents = agents.filter((agent) => agent.status === 'running').length;
  const totalAgents = agents.length;
  const runningTasks = agents.reduce((sum, agent) => sum + (agent.tasks || 0), 0);
  const awaitingApprovals = approvals.length;

  return (
    <div className="kpi-row">
      <KPICard
        label="Active agents"
        value={`${runningAgents} / ${totalAgents}`}
        delta={{ value: `${totalAgents - runningAgents} idle`, direction: 'flat' }}
        icon={FiIcons.FiCpu}
        tone="muted"
      />
      <KPICard
        label="Tasks running"
        value={runningTasks}
        delta={{ value: 'live', direction: 'flat' }}
        icon={FiIcons.FiActivity}
        sparkData={TOKEN_SERIES}
        tone="emerald"
      />
      <KPICard
        label="Awaiting approval"
        value={awaitingApprovals}
        delta={awaitingApprovals > 0 ? { value: 'needs review', direction: 'up' } : null}
        icon={FiIcons.FiCheckSquare}
        tone="crimson"
        onClick={() => navigate('/approvals')}
      />
      {/* Cutover §3: revenue/derived-token figures were mock math over the
          sample fleet (runningTasks × 41 / × 1.8) presented as KPIs. There is
          no billing rollup on this screen yet, so the card states that
          instead of a fabricated dollar figure (dry-run round). */}
      <KPICard
        label="Billing rollup"
        value="Pending"
        delta={{ value: 'metering rollup not wired this round', direction: 'flat' }}
        icon={FiIcons.FiDollarSign}
        sparkData={REVENUE_SERIES}
        tone="violet"
      />
    </div>
  );
}

export default CockpitKPIRow;
